<template>
  <div>
    <NsHeader v-if='loaded'/>
    <div id="qualifications">
      <v-app>
        <feature-flag-app>
          <div id="mainContainer">
            <QualificationsDisplay v-if='loaded'/>
          </div>
        </feature-flag-app>
      </v-app>
    </div>
    <NsFooter v-if='loaded'/>
    <link rel="stylesheet" type="text/css" href="https://use.typekit.net/drl7neu.css">
  </div>
</template>

<script>

import QualificationsDisplay from './views/QualificationsDisplay.vue'
import config from './js/qualificationsConfigService'

import {FeatureFlagApp} from '@nuskin/ns-feature-flags-vue'
import { NsHeader, NsFooter } from '@nuskin/app-components'
import { SalesEventService } from '@nuskin/ns-shop'
import { events } from '@nuskin/ns-util'

import initNuskin from './js/NuskinLoader'
import loadOktaSession from './js/OktaLoader'

import { overrideConfigurationProperty } from '@nuskin/configuration-sdk'
window.overrideContentStackConfig = window.overrideContentStackConfig || overrideConfigurationProperty

export default {
  name: 'qualifications',
  components: {
    QualificationsDisplay,
    NsHeader,
    NsFooter,
    FeatureFlagApp
  },
  data() {
    return {
      loaded: false
    }
  },
  async beforeCreate() {
    try {
      await initNuskin()
      const oktaLoaded = await loadOktaSession()
      if (!oktaLoaded) {
        events.publish(events.authentication.REQUEST_FOR_LOGIN)
      } else {
        await Promise.all([
          config.loadConfig(),
          SalesEventService.init(true)
        ])
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Exclusive Offer app loading error:', e)
    }
    this.loaded = true
  }
}

// This causes jest to ignore this file for coverage as it's not pertinent
/* istanbul ignore file */
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: transparent;
}

.application--wrap {
  background-color: rgb(246,247,247);
}
</style>
